export default __webpack_public_path__ + "static/media/14.50b0621a.jpg";